var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Observable from "zen-observable";
import client from "@irati/utils/services/apollo";
import { waitPromise } from "@irati/utils/promise";
import { attemptToGetCode } from "@irati/utils/services/API/helpers/getCodeFromError";
import tokens from "../../../services/tokens";
var AuthAbstract = /** @class */ (function () {
    function AuthAbstract(_a) {
        var storage = _a.storage;
        this.observers = [];
        this.status = "stopped";
        this._data = null;
        /** @description: Should we wipe all on listen failure?
         * - Most apps no, want to support offline
         * - Internal, typically yes
         */
        this.rejectOnListenFail = false;
        this.storage = storage;
        this.makeInit();
    }
    Object.defineProperty(AuthAbstract.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
            if (value) {
                this.storage.set(value);
                this.observers.forEach(function (observer) {
                    observer.next(value);
                });
            }
            else {
                this.storage.clear();
            }
        },
        enumerable: false,
        configurable: true
    });
    /** @description: You've just logged in or think you have valid resume data, call this. */
    AuthAbstract.prototype.start = function (data) {
        this.status = "started";
        return this.listen(this.query(data), data);
    };
    /** @description: User wants to log out or kill session, call this. */
    AuthAbstract.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.status = "stopped";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, client.clearStore()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        tokens.clear();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/, this.unlisten({ complete: true })];
                }
            });
        });
    };
    /** @description: The auth data, should be used sparingly, you should subscribe tho this. */
    AuthAbstract.prototype.get = function () {
        if (!this.data || !this.isValid(this.data)) {
            throw new Error("[Auth]: Auth not initialised yet.");
        }
        return this.data;
    };
    /** @description: Listen for changes in the auth data. */
    AuthAbstract.prototype.subscribe = function (onNext, onError, onComplete) {
        var _this = this;
        return new Observable(function (observer) {
            _this.storage.get().then(function (auth) {
                observer.next(auth);
            });
            _this.observers.push(observer);
            return function () {
                _this.observers = _this.observers.filter(function (t) { return t !== observer; });
            };
        }).subscribe(onNext, onError, onComplete);
    };
    Object.defineProperty(AuthAbstract.prototype, "isInitialised", {
        /** @description: Has the stream been intialised. */
        get: function () {
            return !!this.watcherPromise;
        },
        enumerable: false,
        configurable: true
    });
    AuthAbstract.prototype.listen = function (query, initialData) {
        var _this = this;
        if (initialData) {
            this.data = initialData;
        }
        if (!this.watcherPromise) {
            this.watcherPromise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var q;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, query()];
                        case 1:
                            q = _a.sent();
                            this.watcher = q.subscribe(function (res) {
                                var data = res.data;
                                _this.data = data;
                                resolve();
                            }, function (err) {
                                if (_this.rejectOnListenFail) {
                                    console.log("[Auth]: resume watch query failed");
                                    return reject(err);
                                }
                                // if we get an error code, server said no so stop
                                if (attemptToGetCode(err)) {
                                    return _this.stop().then(function () { return resolve(); });
                                }
                                else if (initialData && _this.isValid(initialData)) {
                                    // if no error code (offline) and we have enough data, poll until network connection returns
                                    _this.unlisten();
                                    waitPromise(10000).then(function () {
                                        if (_this.status !== "stopped") {
                                            console.log("retrying...");
                                            _this.listen(query, initialData);
                                        }
                                    });
                                }
                                resolve();
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        return this.watcherPromise;
    };
    AuthAbstract.prototype.unlisten = function (_a) {
        var _b = (_a === void 0 ? {} : _a).complete, complete = _b === void 0 ? false : _b;
        if (this.watcher) {
            this.watcher.unsubscribe();
            this.watcher = undefined;
            this.watcherPromise = undefined;
            if (complete) {
                this.data = null;
                this.observers.forEach(function (observer) {
                    observer.complete();
                });
            }
        }
    };
    /**
     * @description: To protect against mulitiple sync init calls, re-write the init function to only call once.
     */
    AuthAbstract.prototype.makeInit = function () {
        var initResult;
        var initFunc = this.init.bind(this);
        this.init = function () {
            if (!initResult) {
                initResult = initFunc();
            }
            return initResult.catch(function (err) {
                initResult = null;
                throw err;
            });
        };
    };
    return AuthAbstract;
}());
export default AuthAbstract;
